import { connect } from 'react-redux';
import { loginAsync, resetPasswordAsync } from '../../../lib/dataLayer';
import ResetPasswordPage from '../components/ResetPasswordPage';

const mapDispatchToProps = {
  onLogin: loginAsync,
  onResetPassword: resetPasswordAsync,
};

const mapStateToProps = (state, ownProps) => ({
  email: decodeURIComponent(ownProps.match.params.email),
  token: ownProps.match.params.token,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ResetPasswordPage);



// WEBPACK FOOTER //
// ./src/modules/ResetPasswordPage/containers/ResetPasswordContainer.js